<template>
    <div class="container">
        <h2>Dashboard</h2>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title">Trades by Date</h5>
                        <TradeByDateChart :tradesByDate="tradesByDate" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import eventBus from '@/utils/eventBus';
import { checkAuth } from '@/utils/auth';
import TradeByDateChart from '@/views/TradesByDateChartComponent.vue';

export default {
    components: {
        TradeByDateChart
    },
    data() {
        return {
            tradesByDate: []
        };
    },
    async mounted() {
        if (!(await checkAuth())) {
            eventBus.emit('show-alert', { message: 'You need to log in to access this page.', type: 'danger' });
            this.$router.push('/');
        } else {
            await this.fetchDashboardData();
        }
    },
    methods: {
        async fetchDashboardData() {
            try {
                const response = await api.get('/v1/dashboard', {
                    headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
                    params: { days: 30 }
                });
                if (response.status === 200 && response.data.data) {
                    this.tradesByDate = Array.isArray(response.data.data.tradesByDate) ? response.data.data.tradesByDate : [];
                } else {
                    this.tradesByDate = [];
                }
            } catch (error) {
                console.error('Error fetching dashboard data:', error);
                this.tradesByDate = [];
                if (error.response.data.message) {
                    eventBus.emit('show-alert', { message: error.response.data.message, type: 'danger' });
                } else {
                    eventBus.emit('show-alert', { message: 'Error fetching dashboard data.', type: 'danger' });
                }
            }
        }
    }
};
</script>